export enum UserType {
  Agent = 'agent',
  Manager = 'manager',
}
